import React, { createContext, forwardRef, useImperativeHandle, useMemo, useState, } from 'react';
import { useUpdateEffect } from 'ahooks';
import { useFetchDataService } from '../hooks/use-fetch-data-service';
import { useToolbarButtons } from '../hooks/use-toolbar-buttons';
export const CardItemsStateCtx = createContext({});
export const CardItemsContext = forwardRef((props, ref) => {
    const { children, tableProps } = props;
    const { operateColumn, toolbar, showSelect, onSelectChange, icon, title, desc, action, subIcon, subTitle, subDesc, subAction, tags, requestConfig, disableDetail, } = tableProps;
    const [selectedKeys, setSelectedKeys] = useState(new Set());
    const data = useFetchDataService({ requestConfig });
    const { totalCount } = data;
    const { loading, dataSource = tableProps.dataSource || [], loadNextPage, refreshAsync, currentPageRefreshAsync, } = data;
    const columns = tableProps.columns || data.columns;
    const primaryKey = useMemo(() => {
        if (tableProps.primaryKey)
            return tableProps.primaryKey;
        return columns?.reduce((result, item) => {
            if (result)
                return result;
            return item.dataIndex;
        }, undefined);
    }, [columns, tableProps.primaryKey]);
    const selectedDataSource = useMemo(() => {
        return [...selectedKeys].map((val) => {
            return dataSource.find((item) => item[primaryKey] === val);
        });
    }, [dataSource, primaryKey, selectedKeys]);
    useUpdateEffect(() => {
        if (!onSelectChange)
            return;
        onSelectChange([...selectedKeys], selectedDataSource);
    }, [selectedKeys, selectedDataSource]);
    useImperativeHandle(ref, () => ({
        refreshAsync,
        currentPageRefreshAsync,
    }));
    // @ts-ignore 临时兼容lowcode
    const listPlaceholder = tableProps.listPlaceholder || tableProps.tableName;
    const toolbarButtons = useToolbarButtons({
        toolbar,
        selectedKeys,
        selectedDataSource,
    });
    const output = useMemo(() => {
        const showTotal = totalCount && totalCount !== 0;
        return {
            toolbarButtons,
            showToolbar: showSelect || showTotal || Boolean(toolbarButtons.length),
            listPlaceholder,
            loading,
            icon,
            title,
            desc,
            action,
            subIcon,
            subTitle,
            subDesc,
            subAction,
            tags,
            totalCount,
            hasNextPage: data.hasNextPage,
            primaryKey,
            dataSource,
            columns: columns || [],
            operateColumn,
            loadNextPage,
            toolbar,
            showSelect,
            selectedKeys,
            setSelectedKeys,
            selectedDataSource,
            disableDetail,
        };
    }, [
        toolbarButtons,
        listPlaceholder,
        loading,
        icon,
        title,
        desc,
        action,
        subIcon,
        subTitle,
        subDesc,
        subAction,
        tags,
        totalCount,
        data.hasNextPage,
        primaryKey,
        dataSource,
        columns,
        operateColumn,
        loadNextPage,
        toolbar,
        showSelect,
        selectedKeys,
        setSelectedKeys,
        selectedDataSource,
        disableDetail,
    ]);
    return (React.createElement(CardItemsStateCtx.Provider, { value: output }, children));
});
